import React from "react";
import { TUnitListingMdl } from "admin/units/_models/UnitListingMdl";
import { useFavoriteToggle } from "users/profile/favorite/useFavoriteToggle";
import { COMMON_RESOURCE } from "_common/resources/BaseResourceStore";
import { IconFavorite } from "../icons/IconFavorite";
import { useCompare } from "properties/propertyCard/components/favorite/compare-provider";
import { Square, SquareCheck, SquareX } from "lucide-react";
import { MAX_COMPARE_ITEMS } from "properties/compare/banner/compare-banner";
import { cn } from "_configs/twconfig";
import { propertiesStore } from "properties/_stores/propertiesStore";

type Props = {
    unit: TUnitListingMdl;
};

export function InventoryFavorite({ unit }: Props) {
    const { isFavorite, toggleFavorite } = useFavoriteToggle(COMMON_RESOURCE.UNIT, unit._id);
    const { itemsSelected, isAlreadyCompared, toggleCompare } = useCompare();
    const property = propertiesStore.getSync(unit.propertyId);
    if (!property) return null;

    return (
        <div className={"flex items-center justify-center gap-x-3"}>
            <IconFavorite
                onClick={() => {
                    toggleFavorite();
                }}
                size="20"
                color="red"
                isFavorite={isFavorite}
            />
            <div
                className={cn({
                    "cursor-pointer": !(itemsSelected.length >= MAX_COMPARE_ITEMS && !isAlreadyCompared(unit._id)),
                    "text-neutral-200": itemsSelected.length >= MAX_COMPARE_ITEMS && !isAlreadyCompared(unit._id),
                    "text-[#1A3A45]": isAlreadyCompared(unit._id),
                })}
                onClick={() => {
                    if (itemsSelected.length >= 5 && !isAlreadyCompared(unit._id)) return;
                    toggleCompare({ itemId: unit._id, resource: COMMON_RESOURCE.UNIT, type: property.type });
                }}
            >
                {isAlreadyCompared(unit._id) ? (
                    <SquareCheck size={20} className="text-[#1A3A45]" />
                ) : itemsSelected.length < MAX_COMPARE_ITEMS ? (
                    <Square size={20} />
                ) : (
                    <SquareX size={20} />
                )}
            </div>
        </div>
    );
}
